import { UIView } from "@uirouter/react";

import {
    FIND_APPS_ABSTRACT_ROUTE,
    FIND_APPS_PAGE_ROUTE_URL,
    FIND_APPS_SEARCH_PAGE_ROUTE,
    SI_ROOT_ROUTE,
} from "app/pages/sales-intelligence/constants/routes";
import FindAppsPageContainer from "app/pages/sales-intelligence/pages/find-apps/containers/FindAppsPageContainer";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import { fallback } from "app/routes/handlers/redirectFunctions/fallback";
import { redirectPipe } from "app/routes/handlers/redirectFunctions/redirectPipe";
import type { IRouterState } from "single-spa/react-app/router/IRouterState";

export const findAppsStateConfig: Record<string, IRouterState> = {
    [FIND_APPS_ABSTRACT_ROUTE]: {
        abstract: true,
        parent: SI_ROOT_ROUTE,
        url: FIND_APPS_PAGE_ROUTE_URL,
        component(...props: unknown[]) {
            return (
                <div className="sw-layout-scrollable-element use-sticky-css-rendering">
                    {/* @ts-expect-error unknown[] passed as UIViewProps */}
                    <UIView {...props} />
                </div>
            );
        },
        configId: "SalesWorkspace",
        configIdDeps: ["WebAnalysis", "MobileWeb", "MobileWebWorldwide"],
        packageName: "salesIntelligence",
        secondaryBarType: "SalesIntelligenceFind",
        isSecondaryBarOpen: false,
    },
    [FIND_APPS_SEARCH_PAGE_ROUTE]: {
        parent: FIND_APPS_ABSTRACT_ROUTE,
        url: "",
        component: FindAppsPageContainer,
        configId: "SalesWorkspace",
        isPrimarySidebarAlwaysOpen: !salesSettingsHelper.isAppsOnly,
        isSecondaryBarOpen: false,
        pageTitle: "si.pages.find_leads.document_title",
        trackingId: {
            section: "Search apps",
            subSection: "Apps advanced search",
            subSubSection: "Apps lead generator",
        },

        secondaryBarType: "SalesIntelligenceFindApps",
        redirectTo: redirectPipe(
            fallback({
                workspace: "salesWorkspace",
            }),
        ),
    } as IRouterState,
};
